import { css, Theme } from "@emotion/react";
import { theme } from "styles/theme";

export const MenuUserStyle = {
  self: ({ colors, fontSize }: Theme) => css`
    background-color: ${theme.colors.gray[850]};
    border-radius: 0 0 10px 10px;
    padding-bottom: 20px;

    & .ant-menu {
      background: unset;
      &-item {
        padding: 0 40px;
        color: ${colors.white};
        width: 100%;
        height: 56px;
        margin: 0;
        border-radius: 0;
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: ${fontSize[16]};
        letter-spacing: 2px;
        transition: unset !important;
        outline: none !important;

        &-selected,
        &:hover {
          background-color: ${theme.colors.orange[100]} !important;
          color: ${colors.black};
          svg,
          path {
            fill: ${colors.black};
          }
        }
      }
      &-title-content {
        transition: unset !important;
        a {
          transition: unset !important;
        }
      }
    }
  `,
};
